// 주소 검색 — 기존 웹과 같은 Daum Postcode 임베드(v2/eval/parts/OrderFormPanel.js 패턴 재사용).
// 스크립트는 public/index.html 이 정적 로드한다. 없으면 호출 측이 이 모달을 열지 않고
// 검차 위치 입력칸(직접 입력)으로 폴백한다.
import React, { useEffect, useRef } from 'react';
import { T } from '../../../theme';
import { SheetFrame } from '../../parts/ConfirmSheet';

function AddrPickModal(props) {
  var t = props.t;
  var boxRef = useRef(null);
  var open = props.open;
  var onPick = props.onPick;

  useEffect(function () {
    if (!open) return undefined;
    var timer = setTimeout(function () {
      var box = boxRef.current;
      if (!box || !window.daum || !window.daum.Postcode) return;
      box.innerHTML = '';
      try {
        new window.daum.Postcode({
          oncomplete: function (data) {
            onPick(String(data.roadAddress || data.jibunAddress || data.address || '').trim());
          }
        }).embed(box, { autoClose: false });
      } catch (e) {
        onPick('');   // 임베드 실패 → 직접 입력 폴백
      }
    }, 50);
    return function () { clearTimeout(timer); };
  }, [open, onPick]);

  if (!open) return null;
  return (<SheetFrame open title={t('simplePickAddr')} onClose={props.onClose} closeLabel={t('actionClose')}>
    <div ref={boxRef} style={{ width: '100%', height: 420, background: T.card }} />
  </SheetFrame>);
}

export default AddrPickModal;
